export enum FeedbackButtonActionBehavior {
  Emit = 'emit',
  Route = 'route'
}
